const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const template = require('./loading_view.html')
const styles = require('./loading_view.less')
const log = require('log').create('loading_view') // eslint-disable-line

/** LoadingView
* a basic loading view which shows a spinner and optionally some text
* @param text (string, optional) text to be shown next to the spinner (e.g. "Loading…")
* @param model (Backbone.Model, optional) model with text attribute.
*   Use this if you need to modify the text of the loading view dynamically
*   Note: don't provide options.text AND options.model. options.text will prevail
* @param className (string, optional) - classname to be applied to the view
*   The 'loading-view' class will be applied regardless. Use a custom classname to modify
*   the appearance of the loading view, or apply CSS to .myfeature .loading-view.
*   Things you might want to modify in CSS: font-size, color, or height.
*   To modify the color of the spinner, you must override the four border rules.
*   See ./loading_view.css
* @param stacked (default=false, optional)
*/

const LoadingView = Marionette.View.extend({

    displayName: 'LoadingView',

    template,

    styles,

    templateContext() {
        return this.options
    },

    initialize(options) {
        _.defaults(this.options, {
            stacked: false,
        })

        if (this.model) {
            this.listenTo(this.model, 'change:text', this.render)
        }
    },

    onRender() {
        this.addClassNames()
    },

    addClassNames() {
        this.$el.addClass('loading-view')
        if (this.options.stacked) this.$el.addClass('stacked')
    },

})

module.exports = LoadingView
